import countryRegionData from 'country-region-data';
import compose from 'lodash/fp/compose';
import filter from 'lodash/fp/filter';
import get from 'lodash/fp/get';
import map from 'lodash/fp/map';
import head from 'lodash/head';

export const countries = countryRegionData.map(({ countryName }) => ({
  label: countryName,
  value: countryName,
}));

export const getRegionsByCountryName = (countryName) =>
  compose(
    map(({ name }) => ({ label: name, value: name })),
    get('regions'),
    head,
    filter({ countryName })
  )(countryRegionData);
